import fetchProject from '../../../Services/fetchProject'

export default () => (dispatch) => {

  dispatch(fetchProject(true))

}
